export default __webpack_public_path__ + "static/media/about.e5e4b179.jpg";